(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["general-feedback-public"] && !Shopify.designMode) return;
  try {
    
function initializeGeneralFeedback(root) {
  root.querySelectorAll('[data-general-feedback]').forEach(section => {
    if (section.dataset.bound) return;
    section.dataset.bound = 'true';
    const form = section.querySelector('[data-feedback-form]');
    if (!form) return;
    const editor = section.dataset.editor === 'true';
    const isTest = section.dataset.testEnabled === 'true';
    const invitationEnabled = section.dataset.invitationEnabled === 'true';
    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-feedback-error]');
    const requiredMessage = error.textContent;
    const gate = section.querySelector('[data-feedback-gate]');
    let token = '';
    let ready = editor;
    let sending = false;
    let complete = false;
    const showSuccess = () => {
      complete = true;
      form.hidden = true;
      if (gate) gate.hidden = true;
      const confirmation = section.querySelector('[data-feedback-confirmation]');
      confirmation.hidden = false;
      confirmation.focus();
      section.scrollIntoView({behavior:'smooth',block:'start'});
    };
    const request = async (action, extra = {}) => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 25000);
      try {
        const response = await fetch('https://umgjmnohquhqvhmkbvfe.supabase.co/functions/v1/' + 'general-feedback-public', {
          method:'POST', credentials:'omit', cache:'no-store', referrerPolicy:'no-referrer',
          headers:{'Content-Type':'application/json'}, signal:controller.signal,
          body:JSON.stringify({action,token,survey_type:section.dataset.surveyType,...extra})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error || section.dataset.testNetwork);
        return result;
      } finally { clearTimeout(timeout); }
    };
    const questions = [...form.querySelectorAll('[data-question]')];
    const sync = () => {
      questions.forEach(group => {
        if (group.dataset.followUpFor) {
          const parent = questions.find(item => item.dataset.questionId === group.dataset.followUpFor);
          const triggers = group.dataset.followUpChoices.split('|');
          const selected = parent && !parent.hidden && [...parent.querySelectorAll('input:checked')].some(input => triggers.includes(input.value));
          group.hidden = !selected;
          group.disabled = !selected;
        }
        const other = group.querySelector('.feedback__other');
        if (other) {
          const selected = [...group.querySelectorAll('input:checked')].some(input => input.value === 'Other');
          other.hidden = !selected;
          other.querySelector('input').disabled = !selected;
          other.querySelector('input').required = selected && group.dataset.otherRequired !== 'false';
        }
        if (group.dataset.usedOnly === 'true') {
          const used = questions[1]?.querySelector('input:checked')?.value === 'Yes';
          group.hidden = !used;
          group.querySelectorAll('input,textarea').forEach(input => { input.disabled = !used; });
        }
      });
    };
    form.addEventListener('change', sync);
    sync();
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!ready || sending || complete) return;
      sync();
      const empty = questions.find(group => !group.hidden && group.dataset.kind === 'multi' && group.dataset.required === 'true' && !group.querySelector('input:checked'));
      error.textContent = requiredMessage;
      error.hidden = !empty;
      if (empty) { empty.querySelector('input').focus(); return; }
      if (!form.reportValidity()) return;
      if (editor) { showSuccess(); return; }
      const responses = {};
      questions.filter(group => !group.hidden && !group.disabled).forEach(group => {
        const id = group.dataset.questionId;
        if (group.dataset.kind === 'text') {
          const value = group.querySelector('input,textarea').value.trim();
          if (value) responses[id] = value;
        } else {
          const selected = [...group.querySelectorAll('input:checked')].map(input => input.value);
          responses[id] = group.dataset.kind === 'multi' ? selected : selected[0];
          if (selected.includes('Other')) responses[id + '_other'] = group.querySelector('.feedback__other input').value.trim();
        }
      });
      sending = true;
      button.disabled = true;
      form.setAttribute('aria-busy','true');
      try {
        const result = await request('submit', {version:section.dataset.surveyVersion,website:form.querySelector('[name="website"]').value,responses,...(!isTest ? {email:form.querySelector('[name="email"]')?.value || null,follow_up_permission:form.querySelector('[name="follow_up_permission"]')?.checked || false} : {})});
        if (result.success !== true || result.is_test !== isTest || !result.submission_id) throw new Error(section.dataset.testNetwork);
        showSuccess();
      } catch (failure) {
        error.textContent = failure.name === 'AbortError' ? section.dataset.testNetwork : (failure.message || section.dataset.testNetwork);
        error.hidden = false;
      } finally {
        sending = false;
        button.disabled = complete;
        form.removeAttribute('aria-busy');
      }
    });
    section.querySelector('[data-feedback-back]')?.addEventListener('click', () => {
      complete = false;
      section.querySelector('[data-feedback-confirmation]').hidden = true;
      form.hidden = false;
      form.querySelector('input,textarea')?.focus();
    });
    if (!editor && (isTest || invitationEnabled)) {
      request('context').then(context => {
        if (context.is_test !== isTest || context.survey_type !== section.dataset.surveyType || context.version !== section.dataset.surveyVersion) throw new Error(section.dataset.testUnavailable);
        token = context.token;
        if (typeof token !== 'string') throw new Error(section.dataset.testUnavailable);
        if (context.submission_id) { showSuccess(); return; }
        if (isTest) section.querySelector('[data-feedback-recipient]').textContent = context.recipient_email;
        ready = true;
        button.disabled = false;
        gate.hidden = true;
        form.hidden = false;
      }).catch(failure => {
        gate.textContent = failure.name === 'AbortError' ? section.dataset.testNetwork : (failure.message || section.dataset.testUnavailable);
      });
    }
  });
}
initializeGeneralFeedback(document);
document.addEventListener('shopify:section:load', () => initializeGeneralFeedback(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-application-form"]) return;
  try {
    
function bindProApplications(root){root.querySelectorAll('[data-pro-application]').forEach(section=>{if(section.dataset.bound)return;section.dataset.bound='true';const form=section.querySelector('form'),file=section.querySelector('[data-pro-file]'),info=section.querySelector('[data-pro-file-info]'),img=section.querySelector('[data-pro-image]'),error=section.querySelector('[data-pro-file-error]');let objectUrl='';const clear=()=>{if(objectUrl)URL.revokeObjectURL(objectUrl);objectUrl='';img.hidden=true;img.removeAttribute('src');info.hidden=true;error.hidden=true;file.setCustomValidity('');};file.addEventListener('change',()=>{clear();const f=file.files[0];if(!f)return;const allowed=['image/jpeg','image/png','image/heic','image/heif','application/pdf'];if(f.size>10*1024*1024||f.size===0||(!allowed.includes(f.type)&&!(/\.(heic|heif)$/i.test(f.name)&&!f.type))){file.value='';error.hidden=false;return;}section.querySelector('[data-pro-filename]').textContent=f.name+' · '+(f.size/1024/1024).toFixed(1)+' MB';info.hidden=false;if(['image/jpeg','image/png'].includes(f.type)){objectUrl=URL.createObjectURL(f);img.src=objectUrl;img.hidden=false;img.onerror=()=>{img.hidden=true;};}});section.querySelector('[data-pro-remove]').addEventListener('click',()=>{clear();file.value='';file.focus();});let submissionId=crypto.randomUUID(),busy=false;
form.addEventListener('input',()=>{if(!busy)submissionId=crypto.randomUUID();});
form.addEventListener('submit',async e=>{
 e.preventDefault();if(busy||!form.reportValidity())return;
 const notice=section.querySelector('[data-pro-submit-notice]'),button=form.querySelector('button[type="submit"]');
 const payload=new FormData(form);payload.set('submission_id',submissionId);
 const controls=Array.from(form.elements).map(el=>[el,el.disabled]);
 busy=true;controls.forEach(([el])=>el.disabled=true);
 notice.textContent=section.dataset.busyMessage;notice.hidden=false;form.setAttribute('aria-busy','true');
 try{
  const response=await fetch(section.dataset.submitEndpoint,{method:'POST',headers:{Authorization:'Bearer '+section.dataset.publicKey,apikey:section.dataset.publicKey},body:payload,signal:AbortSignal.timeout(65000)});
  const result=await response.json();
  if(!response.ok||result.accepted!==true)throw Error(section.dataset.errorMessage);
  form.reset();clear();file.value='';notice.textContent=section.dataset.successMessage;
  section.querySelector('.exo-pro-form__preview').hidden=true;notice.focus();
 }catch{
  controls.forEach(([el,disabled])=>el.disabled=disabled);
  notice.textContent=section.dataset.errorMessage;notice.focus();
 }finally{busy=false;form.removeAttribute('aria-busy');}
});form.querySelector('button[type="submit"]').disabled=false;});}
bindProApplications(document);document.addEventListener('shopify:section:load',()=>bindProApplications(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["survey-feedback"] && !Shopify.designMode) return;
  try {
    
function initializeFeedback(root) {
  root.querySelectorAll('[data-feedback]').forEach(section => {
    if (section.dataset.bound) return;
    section.dataset.bound = 'true';
    const form = section.querySelector('[data-feedback-form]');
    if (!form) return;
    const editor = section.dataset.editor === 'true';
    const isTest = section.dataset.testEnabled === 'true';
    const invitationEnabled = section.dataset.invitationEnabled === 'true';
    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-feedback-error]');
    const requiredMessage = error.textContent;
    const gate = section.querySelector('[data-feedback-gate]');
    let token = '';
    let ready = editor;
    let sending = false;
    let complete = false;
    const showSuccess = () => {
      complete = true;
      form.hidden = true;
      if (gate) gate.hidden = true;
      const confirmation = section.querySelector('[data-feedback-confirmation]');
      confirmation.hidden = false;
      confirmation.focus();
      section.scrollIntoView({behavior:'smooth',block:'start'});
    };
    const request = async (action, extra = {}) => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 25000);
      try {
        const response = await fetch('https://umgjmnohquhqvhmkbvfe.supabase.co/functions/v1/' + (isTest ? 'survey-test' : 'survey-submit-v2'), {
          method:'POST', credentials:'omit', cache:'no-store', referrerPolicy:'no-referrer',
          headers:{'Content-Type':'application/json'}, signal:controller.signal,
          body:JSON.stringify({action,token,survey_type:section.dataset.surveyType,...extra})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error || section.dataset.testNetwork);
        return result;
      } finally { clearTimeout(timeout); }
    };
    const questions = [...form.querySelectorAll('[data-question]')];
    const sync = () => {
      questions.forEach(group => {
        if (group.dataset.followUpFor) {
          const parent = questions.find(item => item.dataset.questionId === group.dataset.followUpFor);
          const triggers = group.dataset.followUpChoices.split('|');
          const selected = parent && !parent.hidden && [...parent.querySelectorAll('input:checked')].some(input => triggers.includes(input.value));
          group.hidden = !selected;
          group.disabled = !selected;
        }
        const other = group.querySelector('.feedback__other');
        if (other) {
          const selected = [...group.querySelectorAll('input:checked')].some(input => input.value === 'Other');
          other.hidden = !selected;
          other.querySelector('input').disabled = !selected;
          other.querySelector('input').required = selected && group.dataset.otherRequired !== 'false';
        }
        if (group.dataset.usedOnly === 'true') {
          const used = questions[1]?.querySelector('input:checked')?.value === 'Yes';
          group.hidden = !used;
          group.querySelectorAll('input,textarea').forEach(input => { input.disabled = !used; });
        }
      });
    };
    form.addEventListener('change', sync);
    sync();
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!ready || sending || complete) return;
      sync();
      const empty = questions.find(group => !group.hidden && group.dataset.kind === 'multi' && group.dataset.required === 'true' && !group.querySelector('input:checked'));
      error.textContent = requiredMessage;
      error.hidden = !empty;
      if (empty) { empty.querySelector('input').focus(); return; }
      if (!form.reportValidity()) return;
      if (editor) { showSuccess(); return; }
      const responses = {};
      questions.filter(group => !group.hidden && !group.disabled).forEach(group => {
        const id = group.dataset.questionId;
        if (group.dataset.kind === 'text') {
          const value = group.querySelector('input,textarea').value.trim();
          if (value) responses[id] = value;
        } else {
          const selected = [...group.querySelectorAll('input:checked')].map(input => input.value);
          responses[id] = group.dataset.kind === 'multi' ? selected : selected[0];
          if (selected.includes('Other')) responses[id + '_other'] = group.querySelector('.feedback__other input').value.trim();
        }
      });
      sending = true;
      button.disabled = true;
      form.setAttribute('aria-busy','true');
      try {
        const result = await request('submit', {version:section.dataset.surveyVersion,responses,...(!isTest ? {email:form.querySelector('[name="email"]')?.value || null,follow_up_permission:form.querySelector('[name="follow_up_permission"]')?.checked || false} : {})});
        if (result.success !== true || result.is_test !== isTest || !result.submission_id) throw new Error(section.dataset.testNetwork);
        showSuccess();
      } catch (failure) {
        error.textContent = failure.name === 'AbortError' ? section.dataset.testNetwork : (failure.message || section.dataset.testNetwork);
        error.hidden = false;
      } finally {
        sending = false;
        button.disabled = complete;
        form.removeAttribute('aria-busy');
      }
    });
    section.querySelector('[data-feedback-back]')?.addEventListener('click', () => {
      complete = false;
      section.querySelector('[data-feedback-confirmation]').hidden = true;
      form.hidden = false;
      form.querySelector('input,textarea')?.focus();
    });
    if (!editor && (isTest || invitationEnabled)) {
      token = new URLSearchParams(window.location.hash.slice(1)).get('survey_token') || '';
      // Keep the bearer token out of subsequent navigation URLs and referrers.
      if (token) {
        try { window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search); } catch {}
      }
      if (!/^[a-f0-9]{64}$/.test(token)) {
        gate.textContent = section.dataset.testUnavailable;
        return;
      }
      request('context').then(context => {
        if (context.is_test !== isTest || context.survey_type !== section.dataset.surveyType || context.version !== section.dataset.surveyVersion) throw new Error(section.dataset.testUnavailable);
        if (context.submission_id) { showSuccess(); return; }
        if (isTest) section.querySelector('[data-feedback-recipient]').textContent = context.recipient_email;
        ready = true;
        button.disabled = false;
        gate.hidden = true;
        form.hidden = false;
      }).catch(failure => {
        gate.textContent = failure.name === 'AbortError' ? section.dataset.testNetwork : (failure.message || section.dataset.testUnavailable);
      });
    }
  });
}
initializeFeedback(document);
document.addEventListener('shopify:section:load', () => initializeFeedback(document));

  } catch(e) { console.error(e); }
})();
})();
